/* AD Perfumes — search suggestions while typing.
   Uses Shopify's predictive search endpoint (/search/suggest) rendered through
   the 'predictive-search' section. Pressing Enter always runs a full search. */
(function () {
  'use strict';

  var ADP = (window.ADP = window.ADP || {});
  var routes = ADP.routes || {};

  function setup(form) {
    if (form.__adpPredictive) return;
    form.__adpPredictive = true;

    var input = form.querySelector('[data-predictive-search-input]');
    var panel = form.parentElement.querySelector('[data-predictive-results]');
    if (!input || !panel) return;

    var controller = null;
    var activeIndex = -1;

    function close() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    }

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function highlight(index) {
      var opts = options();
      opts.forEach(function (o) { o.setAttribute('aria-selected', 'false'); });
      if (index < 0 || index >= opts.length) {
        activeIndex = -1;
        input.removeAttribute('aria-activedescendant');
        return;
      }
      activeIndex = index;
      opts[index].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', opts[index].id);
      opts[index].scrollIntoView({ block: 'nearest' });
    }

    var search = ADP.debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = routes.predictiveSearch +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page' +
        '&resources[limit]=6' +
        '&resources[options][unavailable_products]=last' +
        '&section_id=predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var content = doc.querySelector('.predictive');
          if (!content || input.value.trim() !== q) return;
          panel.innerHTML = '';
          panel.appendChild(content);
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          activeIndex = -1;
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          close();
        });
    }, 250);

    input.addEventListener('input', search);
    input.addEventListener('focus', function () { if (panel.innerHTML.trim() && input.value.trim().length >= 2) { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); } });

    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      var opts = options();
      if (e.key === 'ArrowDown') { e.preventDefault(); highlight(Math.min(activeIndex + 1, opts.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(activeIndex - 1); }
      else if (e.key === 'Enter' && activeIndex > -1) {
        var link = opts[activeIndex].querySelector('a');
        if (link) { e.preventDefault(); window.location.href = link.href; }
      } else if (e.key === 'Escape') { close(); }
    });

    document.addEventListener('click', function (e) {
      if (!form.parentElement.contains(e.target)) close();
    });
  }

  function init() {
    document.querySelectorAll('[data-predictive-search-form]').forEach(setup);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
